export function tryJsonStringify<T>(object: T | null | undefined, replacer?: any, spaces?: number): string | null {
  if (typeof object === 'undefined') {
    return null;
  }

  try {
    return JSON.stringify(object, replacer, spaces);
  } catch {
    return null;
  }
}
